import React, { useEffect, useState } from 'react';
import { FaFilter, FaRedoAlt, FaSchool, FaUserGraduate } from 'react-icons/fa';
import { procurementAPI } from '../../utils/api';

export default function ProcurementEnrollmentPage() {
  const [limit, setLimit] = useState(25);
  const [data, setData] = useState({ selectedSchools: 0, totalEnrollment: 0, schools: [] });
  const [loading, setLoading] = useState(false);

  const load = () => {
    setLoading(true);
    procurementAPI.enrollmentAnalytics({ limit })
      .then(res => setData(res.data || { selectedSchools: 0, totalEnrollment: 0, schools: [] }))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section className="enrollment-page">
      <header className="enrollment-heading">
        <div>
          <span className="enrollment-eyebrow"><FaFilter /> Procurement planning</span>
          <h1>Enrollment Demand</h1>
          <p>Review school-wise enrollment totals before tender and work order planning.</p>
        </div>
        <div className="enrollment-summary">
          <span>Total students</span>
          <strong>{Number(data.totalEnrollment || 0).toLocaleString()}</strong>
          <small>{data.selectedSchools} schools included</small>
        </div>
      </header>

      <div className="enrollment-filter-card">
        <div className="enrollment-filters">
          <label className="enrollment-filter">
            <span>Schools to include</span>
            <select value={limit} onChange={event => setLimit(Number(event.target.value))}>
              {[10, 25, 50, 100, 250, 0].map(value => (
                <option key={value} value={value}>{value === 0 ? 'All schools' : `${value} schools`}</option>
              ))}
            </select>
          </label>
          <button type="button" className="save-button" onClick={load}><FaRedoAlt /> Apply</button>
        </div>
      </div>

      <div className="enrollment-workspace" style={{ display: 'block' }}>
        <div className="enrollment-table-card">
          <div className="enrollment-table-context">
            <div><FaSchool /><span><b>School Demand</b><small>{loading ? 'Refreshing totals...' : 'Sorted by total enrollment'}</small></span></div>
            <span className="status"><FaUserGraduate /> {Number(data.totalEnrollment || 0).toLocaleString()}</span>
          </div>
          <div className="enrollment-table-scroll">
            <table className="enrollment-grid">
              <thead><tr><th>School</th><th>SEMIS</th><th>Total Enrollment</th></tr></thead>
              <tbody>
                {(data.schools || []).map(school => (
                  <tr key={school.schoolId}>
                    <td>{school.schoolName}</td>
                    <td>{school.semisCode || '-'}</td>
                    <td>{Number(school.totalEnrollment || 0).toLocaleString()}</td>
                  </tr>
                ))}
                {!loading && !data.schools?.length && <tr><td colSpan="3">No enrollment records found.</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}
